import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fuma_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUS_LABELS = {
  in_attesa: "In attesa",
  accettato: "Accettato",
  in_preparazione: "In preparazione",
  pronto: "Pronto",
  rider_assegnato: "Rider assegnato",
  ritirato: "Ritirato",
  in_consegna: "In consegna",
  consegnato: "Consegnato",
  annullato: "Annullato",
};

export const STATUS_COLORS = {
  in_attesa: "bg-amber-500/20 text-amber-400 border-amber-500/30",
  accettato: "bg-blue-500/20 text-blue-400 border-blue-500/30",
  in_preparazione: "bg-blue-500/20 text-blue-400 border-blue-500/30",
  pronto: "bg-[#00E676]/20 text-[#00E676] border-[#00E676]/30",
  rider_assegnato: "bg-purple-500/20 text-purple-400 border-purple-500/30",
  ritirato: "bg-purple-500/20 text-purple-400 border-purple-500/30",
  in_consegna: "bg-cyan-500/20 text-cyan-400 border-cyan-500/30",
  consegnato: "bg-[#00E676]/20 text-[#00E676] border-[#00E676]/30",
  annullato: "bg-red-500/20 text-red-400 border-red-500/30",
};

export const ORDER_FLOW = [
  "in_attesa", "accettato", "in_preparazione", "pronto",
  "rider_assegnato", "ritirato", "in_consegna", "consegnato",
];

export default api;
